import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createStaticVNode as _createStaticVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "py-10" }
const _hoisted_2 = /*#__PURE__*/_createStaticVNode("<h1 class=\"anchor fw-bolder mb-5\" id=\"badge\"><a href=\"#badge\"></a> Badge </h1><div class=\"py-5\"> Add a badge element using <code>.badge</code> component inside a symbol element: </div><div class=\"py-5\"><div class=\"rounded border p-10 pb-0 d-flex flex-wrap\"><div class=\"symbol symbol-50px me-10 mb-10\"><div class=\"symbol-label fs-2 fw-bold\">A</div><span class=\"badge badge-circle bg-danger\">3</span></div><div class=\"symbol symbol-50px me-10 mb-10\"><div class=\"symbol-label fs-2 fw-bold\">A</div><span class=\"badge badge-circle bg-danger top-100\">3</span></div><div class=\"symbol symbol-50px me-10 mb-10\"><div class=\"symbol-label fs-2 fw-bold\">A</div><span class=\"badge badge-circle bg-danger start-0\">3</span></div><div class=\"symbol symbol-50px me-10 mb-10\"><div class=\"symbol-label fs-2 fw-bold\">A</div><span class=\"badge badge-circle bg-danger start-0 top-100\">3</span></div></div></div>", 3)
const _hoisted_5 = { class: "py-5" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_CodeHighlighter = _resolveComponent("CodeHighlighter")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", _hoisted_5, [
      _createVNode(_component_CodeHighlighter, { lang: "html" }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(`
        <div class="symbol symbol-50px">
          <div class="symbol-label fs-2 fw-bold">A</div>
          <span class="badge badge-circle bg-danger">3</span>
        </div>

        <div class="symbol symbol-50px">
          <div class="symbol-label fs-2 fw-bold">A</div>
          <span class="badge badge-circle bg-danger top-100">3</span>
        </div>

        <div class="symbol symbol-50px">
          <div class="symbol-label fs-2 fw-bold">A</div>
          <span class="badge badge-circle bg-danger start-0">3</span>
        </div>

        <div class="symbol symbol-50px">
          <div class="symbol-label fs-2 fw-bold">A</div>
          <span class="badge badge-circle bg-danger start-0 top-100">3</span>
        </div>
        `))
        ]),
        _: 1
      })
    ])
  ]))
}